import { render, staticRenderFns } from "./ProductRanking.vue?vue&type=template&id=192cdd00&"
import script from "./ProductRanking.vue?vue&type=script&lang=js&"
export * from "./ProductRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports